import React from 'react'
import AblContext from "../Context/AblContext";

export function useAblContext() {
  const context = React.useContext(AblContext);

  if(typeof context === 'undefined')
    throw new Error('useAblContext must be use within an useAblContext')

  return context;
}
